<template>
  <el-container>
    <el-header>
      <!--步骤条提示-->
      <el-steps
        class="steps"
        :active="active"
        finish-status="success"
        align-center
      >
        <el-step title="机构基本信息"></el-step>
        <el-step title="机构课程分配"></el-step>
        <!-- 编辑显示第三步-->
        <el-step title="已分配课程管理" v-if="editFlag"></el-step>
      </el-steps>
    </el-header>
    <el-main>
      <!-- 基本信息-->

      <el-container v-if="active === 0" class="info-container">
        <el-form
          v-if="active === 0"
          :model="infoFormData"
          ref="infoFormData"
          label-width="90px"
          class="demo-infoFormData"
        >
          <el-form-item label="机构名称" required>
            <el-input
              v-model="infoFormData.name"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="机构代码" required>
            <el-input
              v-model="infoFormData.code"
              :disabled="editFlag"
              placeholder="请输入英文和数字"
              maxlength="6"
              @change="codeChange"
            ></el-input>
          </el-form-item>
          <el-form-item label="机构类型" required>
            <el-select
              v-model="infoFormData.type"
              placeholder="请选择机构类型"
              class="select"
            >
              <el-option label="学校" value="1"></el-option>
              <el-option label="小型机构" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="省份" required>
            <el-input
              v-model="infoFormData.province"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="城市" required>
            <el-input
              v-model="infoFormData.city"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="地址" required>
            <el-input
              v-model="infoFormData.address"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人" required>
            <el-input
              v-model="infoFormData.contact"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="证件号" required>
            <el-input
              v-model="infoFormData.identity"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" required>
            <el-input
              v-model="infoFormData.mobile"
              maxlength="11"
              placeholder="请输入11位手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户名" v-if="!editFlag" required>
            <el-input
              v-model="infoFormData.loginName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" v-if="!editFlag" required>
            <el-input
              v-model="infoFormData.password"
              minlength="6"
              maxlength="16"
              placeholder="包含英文、数字、符号其中2项，6-16位"
            ></el-input>
          </el-form-item>
          <el-form-item label="学生人数" required>
            <el-input
              v-model="infoFormData.userQuota"
              p
              laceholder="请输入整数"
            ></el-input>
          </el-form-item>
          <el-form-item label="有效期" required>
            <el-date-picker
              class="date"
              type="date"
              placeholder="开始日期"
              style="width: 142px;"
              v-model="infoFormData.validDate"
              value-format="yyyyMMdd"
            ></el-date-picker>
            -
            <el-date-picker
              class="date"
              type="date"
              placeholder="结束日期"
              style="width: 145px;"
              v-model="infoFormData.expireDate"
              value-format="yyyyMMdd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="机构状态" v-if="editFlag">
            <el-select
              v-model="infoFormData.status"
              placeholder="请选择机构状态"
              class="select"
            >
              <el-option label="启用" :value="1"></el-option>
              <el-option label="未启用" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-container>

      <!-- 课程分配-->
      <el-container v-if="active === 1" class=" allocate-container">
        <div class="table-container">
          <!--乐器-->
          <el-table
            border
            class="drum-table"
            :data="drum_table"
            @select="drumRowClick"
            @select-all="handelSelectAll"
            ref="drumTable"
            tooltip-effect="dark"
          >
            <el-table-column type="selection" width="40"> </el-table-column>
            <el-table-column prop="name" label="乐器" align="center">
            </el-table-column>
          </el-table>

          <!--曲册-->
          <el-table
            border
            class="album-table"
            :data="album_table"
            @select="albumRowClick"
            @select-all="handelSelectAlbumAll"
            ref="albumTable"
            tooltip-effect="dark"
          >
            <el-table-column type="selection" width="40"> </el-table-column>
            <el-table-column prop="name" label="曲册" align="center">
            </el-table-column>
          </el-table>

          <!--章节               @selection-change="handleChapterSelectionChange"-->
          <el-table
            border
            class="chapter-table"
            :data="chapter_table"
            ref="chapterTable"
            @select="chapterRowClick"
            @select-all="handelSelectChapterAll"
            tooltip-effect="dark"
          >
            <el-table-column type="selection" width="40"> </el-table-column>
            <el-table-column
              prop="name"
              label="章节"
              class="chapter-row"
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>

        <el-button class="submit theme-btn" type="primary" plain @click="add"
          >添加至预览</el-button
        >

        <!--添加预览-->
        <div class="confirmInfo">
          <div class="info-title">
            <span>乐器</span>
            <span class="border-left border-right">曲册</span>
            <span>章节</span>
            <span class="border-left">操作</span>
          </div>
          <div class="info-class">
            <!--每种乐器的分配情况-->
            <div
              class="info-class-item"
              v-if="previewList.length > 0"
              v-for="(item, index) in previewList"
              :key="index"
            >
              <div v-text="item.name" class="drum-info">
                爵士鼓
              </div>
              <div class="album-info">
                <!--每种乐器的曲册的分配情况-->
                <div
                  class="album-info-item"
                  v-for="(album, albumIndex) in item.albums"
                  :key="albumIndex"
                >
                  <div class="album-info-left" v-text="album.name"></div>
                  <div class="chapter-info">
                    <!--每种曲册的章节-->
                    <div
                      class="chapter-info-item"
                      v-for="(chapter, chapterIndex) in album.chapters"
                      :key="chapterIndex"
                    >
                      <div
                        class="chapter-info-left"
                        v-text="chapter.name"
                      ></div>
                      <div class="operate">
                        <span
                          class="delete-btn"
                          @click="
                            deleteShowAndSubmitIds(
                              index,
                              albumIndex,
                              chapterIndex,
                              chapter.id
                            )
                          "
                          >x</span
                        >
                        <!--<el-button c size="mini"  @click="deleteShowAndSubmitIds(index,albumIndex,chapterIndex,chapter.id)">x</el-button>-->
                        <!--<el-button type="danger"  circle class="circle-btn"-->
                        <!--@click="deleteShowAndSubmitIds(index,albumIndex,chapterIndex,chapter.id)">x</el-button>-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-container>

      <!--已添加课程管理-->
      <el-container v-if="active === 2" class="organ-added">
        <div class="organ-course">
          <el-table :data="organCourses" @selection-change="handleSelectionDel">
            <!--多选-->
            <el-table-column type="selection"> </el-table-column>
            <el-table-column
              prop="title"
              label="曲目名称"
              width="150"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="instrument"
              label="乐器"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="book"
              label="曲册"
              width="150"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="chapter"
              label="章节"
              width="180"
              align="center"
            ></el-table-column>
            <el-table-column label="操作" width="80" align="center">
              <!-- <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  plain
                  @click="singleDel(scope.$index, scope.row)">删除
                </el-button>
              </template> -->
            </el-table-column>
          </el-table>
          <!-- <div class="moreBtn">
            <el-button @click="batchDel" type="danger" plain>批量删除</el-button>
          </div> -->
        </div>
      </el-container>

      <!--步骤按钮-->
      <div class="main-button">
        <el-button
          class="addBtn theme-btn"
          type="primary"
          plain
          @click="upStep"
          v-if="active !== 0"
          >上一步
        </el-button>
        <el-button
          class="addBtn theme-btn"
          @click="nextStep"
          v-if="editFlag ? active < 2 : active < 1"
          type="primary"
          plain
          >下一步
        </el-button>
        <el-button
          class="addBtn theme-btn"
          type="primary"
          plain
          @click="saveInfo"
          v-if="editFlag && active === 0"
          >保 &nbsp;&nbsp;存
        </el-button>
        <el-button
          class="addBtn theme-btn"
          @click="submitAdd"
          v-if="active === 1"
          type="primary"
          plain
          >保 &nbsp;&nbsp;存
        </el-button>
      </div>
    </el-main>
  </el-container>
</template>

<script>
/**
 * 预览方案：
 * 点击添加  生成预览一条信息；  点击删除   就根据id删除和下标  删除预览信息中的对应章节、  并删除要添加到数据库中的id列表
 *
 * */
import OrganDetail from "./OrganDetail";

export default {
  name: "AddOrgan",
  props: ["editFlag", "organId"],
  components: {
    "organ-detail": OrganDetail
  },
  data() {
    return {
      // 步骤条控制
      active: 0,

      /**
         *     "address": "闵行500弄", // 地址
         "city": "上海", // 城市
         "contact": "微微", // 联系人、真实姓名
         "courses": [], // 课程列表   // 0  无效 要选实际的课程
         "expireDate": "", // 有效时间
         "loginName": "root01",  // 登录名、昵称、用户名
         "mobile": "12345678921",    // 手机号
         "name": "阿里路亚",      // 机构名称
         "password": "123456",  // 密码
         "province": "上海",  //  省份
         "type": "民营",    //机构类型
         "userQuota": 200,     // 学生额数
         "validDate": "" // 起效时间
         */

      //基本信息表单数据
      infoFormData: {
        address: "", // 地址
        code: "", // 机构代码
        city: "", // 城市
        contact: "", // 联系人、真实姓名
        identity: "", // 证件号或者营业执照号
        courses: [], // 课程列表   // 0  无效 要选实际的课程
        expireDate: "", // 有效时间
        loginName: "", // 登录名、昵称、用户名
        mobile: "", // 手机号
        name: "", // 机构名称
        password: "", // 密码
        province: "", //  省份
        type: "", //机构类型
        userQuota: 0, // 学生额数
        validDate: "", // 起效时间
        isAgent: "" // 是否为协会承办单位
      },

      // 表单数据
      drum_table: [],
      album_table: [],
      chapter_table: [],

      // 预览列表  json对象  和保存的数据形式不同 选择一个乐器 就push一个对象
      previewList: [],

      // 当前选中的课程  json对象
      currentCourse: "",

      // 当前选中的课程id 在添加的时候判断重复
      currentCourseId: [],

      // 当前选中的曲册
      currentAlbum: "",

      //  本次乐器已选曲册id   判断是否重复
      currentAlbumId: [],

      //  当前曲册选中的章节id 要这个只是不想再遍历章节 取id
      chaptersId: [],

      //当前选中的章节
      chapters: [],

      // 提交的章节
      submitChaptersId: [],

      //  已添加------------------------------------------------------
      //当前机构id:
      currentOrganId: "",

      //  机构已添加课程
      organCourses: [],

      // 多选要删除的数据
      selectContentDel: [],

      //   编辑添加表格
      //   搜索
      // 搜索条件
      search: "",

      // 选择曲目的结果
      selectAlbumValue: "",

      // 协会可分配课程
      courseDataList: [],

      // 编辑添加列表
      confirmAdd: [],

      //  机构编号重复标记
      codeFlag: false
    };
  },
  created() {
    // console.log(this.editFlag);
    // console.log(this.organId);
    if (this.editFlag) {
      //编辑获取机构详情
      // this.$message("编辑获取机构详情");
      this.getOrganDetail();
      //   编辑获取协会课分配资源
      //  获取机构已添加的课程
      this.getOrganCourses();
      this.getData(0, 0);
    } else {
      //  获取类目信息
      this.getData(0, 0);
    }
  },
  methods: {
    //上一步
    upStep() {
      this.active--;
    },

    // 下一步
    nextStep() {
      // 基本信息下一步校验
      if (this.active === 0) {
        console.log(this.infoFormData);
        // 基本信息非空校验
        if (!this.infoFormData.name) {
          return this.$message.error("机构名称不能为空！");
        }
        if (!this.infoFormData.code && !this.editFlag) {
          return this.$message.error("机构代码不能为空！");
        }
        if (!this.tools.isIntAndEg(this.infoFormData.code)) {
          return this.$message.error("机构代码只能由英文和数字组成！");
        }
        if (!this.infoFormData.type) {
          return this.$message.error("机构类型不能为空！");
        }
        if (!this.infoFormData.province) {
          return this.$message.error("省份不能为空！");
        }
        if (!this.infoFormData.city) {
          return this.$message.error("城市不能为空！");
        }
        if (!this.infoFormData.address) {
          return this.$message.error("地址不能为空！");
        }
        if (!this.infoFormData.contact) {
          return this.$message.error("联系人不能为空！");
        }
        if (!this.infoFormData.identity) {
          return this.$message.error("证件号不能为空！");
        }
        if (!this.infoFormData.mobile) {
          return this.$message.error("手机号不能为空！");
        }
        if (!this.infoFormData.loginName) {
          return this.$message.error("用户名不能为空！");
        }
        if (!this.infoFormData.password && !this.editFlag) {
          return this.$message.error("密码不能为空！");
        }
        if (!this.infoFormData.userQuota) {
          return this.$message.error("学生人数不能为空！");
        }
        if (!this.editFlag) {
          // 密码校验   编辑不做此校验
          if (this.tools.passwordCheck(this.infoFormData.password)) {
            return this.$message.error(
              "密码长度6-16位，由字母、数字、符号,至少2项组合而成。"
            );
          }
        }
        //   学生人数 手机号整数校验
        if (this.tools.isInteger(this.infoFormData.mobile)) {
          return this.$message.error("手机号必须为整数！");
        }
        if (this.tools.isInteger(this.infoFormData.userQuota)) {
          return this.$message.error("学生人数必须为整数！");
        }
        // 时间校验  有效期大于起效期
        if (!(this.infoFormData.expireDate > this.infoFormData.validDate)) {
          return this.$message.error("开始日期必须大于结束日期！");
        }
      }

      // 编辑时课程分配下一步获取已分配课程
      if (this.editFlag && this.active === 1) {
        this.getOrganCourses();
      }

      this.active++;
    },

    /**
     * 校验机构编号是否重复
     * 返回结果  data字段值为0表示未占用，1表示占用
     * 重复置空
     * */
    codeChange() {
      //  customer/code/check.json
      let res = this.$api.get("/customer/code/check.json", {
        code: this.infoFormData.code
      });
      res
        .then(
          success => {
            if (success.data === 1) {
              this.infoFormData.code = "";
              this.$message.error("机构编号已被占用，请重新输入！");
            }
          },
          error => {
            this.infoFormData.code = "";
            this.$message.error(error.msg);
          }
        )
        .catch(err => {
          this.infoFormData.code = "";
          this.$message.error("机构编号校验异常！");
        });
    },

    /**
     *  // 添加
     * 1. 将当前曲册列表添加到当前乐器曲册列表
     * 2. 将当前乐器添加到预览列表
     *
     * */
    add() {
      /**    当前选中的章节列表在添加时候清空
       *  判断当前乐器是否存在  预览列表中 不存在添加新乐器  如果存在  判断曲册是否存在 不存在  添加新曲册  ，存在  过滤重复章节   在预览列表中操作
       * */

      if (this.chapters.length === 0) {
        return this.$message.error("请选择章节");
      }
      // 判断重复
      this.removeDup();
    },

    //判断重复   保证预览中没有重复的数据
    removeDup() {
      // 当前的曲册 章节 都没有重复
      this.currentAlbum.chapters = this.chapters;

      // 判断乐器、乐器中的曲册是否重复  不判断章节是否重复
      // 记录乐器、曲册重复位置
      let courseIndex = -1,
        albumIndex = -1;
      // 获得重复的项
      let album = "",
        course = "";
      // 判断乐器是否已经选择  已选则不在新建
      if (this.previewList.length > 0) {
        course = this.previewList.filter((item, index) => {
          if (item.id === this.currentCourse.id) {
            courseIndex = index;
            return item.id === this.currentCourse.id;
          }
        });

        if (courseIndex !== -1) {
          // this.$message.error("该乐器已经选择");
          console.log("该乐器已经存在, 乐器位置：" + courseIndex);
          album = this.previewList[courseIndex].albums.filter((item, index) => {
            // item 是重复乐器的曲册
            if (item.id === this.currentAlbum.id) {
              albumIndex = index;
              return item.id === this.currentAlbum.id;
            }
          });

          if (albumIndex !== -1) {
            // 当前的曲册重复了   提示
            // 统一先替换
            // this.$message.error("当前的曲册已重新选择！");
            console.log(
              "当前的曲册已存在 , 已重新选择！ 曲册位置：" + albumIndex
            );
            // 先删除原来的
            this.previewList[courseIndex].albums.splice(albumIndex, 1);
            // 找到该乐器  追加当前的曲册
            this.previewList[courseIndex].albums.push(this.currentAlbum);
            // console.log(this.previewList);
            // console.log(this.previewList[courseIndex].albums[albumIndex]);
          } else {
            //新的曲册
            // 找到该课程  新增曲册
            // this.$message("新的曲册");
            // this.currentCourse.albums.push(this.currentAlbum);
            this.previewList[courseIndex].albums.push(this.currentAlbum);
          }
        } else {
          //  新的课程
          // this.$message('新的课程');
          this.currentCourse.albums.push(this.currentAlbum);
          this.previewList.push(this.currentCourse);
        }
      } else {
        // 新初始增
        // this.$message('新初始增');
        this.currentCourse.albums.push(this.currentAlbum);
        this.previewList.push(this.currentCourse);
      }
    },

    /**
     * 新增 !editFlag
     *
     * 编辑  editFlag
     * */
    // 提交添加
    submitAdd() {
      // // 时间转化 么得问题
      // this.infoFormData.expireDate = this.dateStr(this.infoFormData.expireDate);
      // this.infoFormData.validDate = this.dateStr(this.infoFormData.validDate);
      console.log(this.previewList);
      if (this.previewList.length === 0) {
        return this.$message.error("您还未添加课程！");
      }

      let idList = [];
      this.previewList.forEach(drum => {
        drum.albums.forEach(album => {
          album.chapters.forEach(chapter => {
            idList.push(chapter.id);
          });
        });
      });
      console.log("要添加的章节");
      console.log(idList);

      if (this.editFlag) {
        //  编辑添加

        let param = {
          id: this.organId,
          courseList: idList
        };

        // console.log("编辑添加保存");
        // console.log(param);

        let res = this.$api.post("/customer/course/add.json", param); // 返回的是一个promise
        res
          .then(
            success => {
              // 成功才会有数据
              if (success.code === 200) {
                this.$message({
                  message: "添加成功!",
                  type: "success"
                });
                // 清空数据
                this.chapter_table = [];
                this.album_table = [];
                this.previewList = [];
                // 重新获取机构已分配课程
                // this.getOrganCourses()
              } else {
                this.$message.error(success.msg);
              }
            },
            err => {
              this.$message.error(err.msg);
            }
          )
          .catch(err => {
            console.log(err);
            this.$message.error("添加异常!");
          });
      } else {
        //   新增添加
        this.infoFormData.courses = idList;
        // this.$message('新增添加');
        let res = this.$api.post("/customer/add.json", this.infoFormData); // 返回的是一个promise
        res
          .then(
            success => {
              // 成功才会有数据
              if (success.code === 200) {
                this.$message({
                  message: "添加成功!",
                  type: "success"
                });
                // 清空数据
                this.chapter_table = [];
                this.album_table = [];
                this.previewList = [];
              } else {
                this.$message.error(success.msg);
              }
            },
            err => {
              this.$message.error(err.msg);
            }
          )
          .catch(err => {
            console.log(err);
            this.$message.error("添加异常!");
          });
      }
    },
    // 时间转换成字符串
    dateStr(date) {
      //获取日期里的年、月、日
      let year = date.getFullYear(),
        month = date.getMonth() + 1,
        sun = date.getDate();
      return year + this.mendZero(month) + this.mendZero(sun);
    },
    // 时间转换补0
    mendZero(num) {
      return (num = num < 10 ? "0" + num : num);
    },

    /**
     * id  :  pid 的值  默认pid 为0  获取的是乐器列表  获取曲册信息pid为乐器的id  以此类推
     * flag  : 请求标记
     * */

    // 获取类目列表
    getData(id, flag) {
      let params = {
        pid: id ? id : 0
      };
      let res = this.$api.get("/category/list.json", params);
      res
        .then(
          success => {
            if (flag === 0) {
              this.drum_table = success.data;
              console.log(this.drum_table);
            } else if (flag === 1) {
              this.album_table = success.data;
            } else {
              this.chapter_table = success.data;
            }
          },
          error => {
            this.$message.error(error.msg);
          }
        )
        .catch(err => {
          console.log(err);
          this.$message.error("数据请求异常！");
        });
    },

    // 获取机构已经添加的课程
    getOrganCourses() {
      // 根据机构名  获取机构id   下次要在添加的时候返回一个id么？
      let param = {
        id: this.organId
      };
      let res = this.$api.get("/customer/course.json", param); // 返回的是一个promise
      res
        .then(
          success => {
            this.organCourses = success.data.courses;
            console.log("已添加的课程");
            console.log(this.organCourses);
          },
          err => {
            this.$message.error(err.msg);
          }
        )
        .catch(err => {
          console.log(err);
          this.$message.error("数据请求异常！");
        });
    },

    /**
     * 1 获取曲册信息
     * 2 改变其他已选选项状态
     * 3 生成一个预览对象，此时并没有曲册的信息  在点击添加时添加到预览列表中
     * */

    //乐器单选
    drumRowClick(selection, row) {
      if (selection.length === 0) {
        this.chapter_table = [];
        this.album_table = [];
        return;
      }
      //将显示的曲册和章节删掉
      this.chapter_table = [];
      this.album_table = [];
      // 获取该乐器的曲册信息
      this.getData(row.id, 1);
      // 将其他项变为选不中 这时候只有两项   第一项变为选不中就可以了
      if (selection.length > 1) {
        this.$refs.drumTable.toggleRowSelection(selection[0], false);
      }

      // 向当前选中的课程中添加一个课程对象,
      this.currentCourse = {
        id: row.id, //乐器id
        name: row.name,
        albums: []
      };
    },

    // 取消选中
    handelSelectAll() {
      this.$refs.drumTable.clearSelection();
    },

    // 曲册全选  取消选中
    handelSelectAlbumAll() {
      this.$refs.albumTable.clearSelection();
    },

    /**
     * 1  获取章节信息
     * 2  改变其他已选选项状态
     * 3  生成一个曲册对象 此时没有章节  点击确定添加到当前乐器的曲册列表
     *
     * */
    //曲册单选
    albumRowClick(selection, row, index) {
      if (selection.length === 0) {
        //  清空章节列表
        this.chapter_table = [];
        return;
      }
      if (selection.length > 1) {
        this.$refs.albumTable.toggleRowSelection(selection[0], false);
      }

      this.getData(row.id, 2);
      this.currentAlbum = {
        id: row.id,
        name: row.name,
        //选择该乐器的一个章节  添加一个章节对象
        chapters: []
      };
    },

    //章节单选
    chapterRowClick(selection, row) {
      if (selection.length > 0) {
        // 当前选中的肯定没有重复的
        this.chapters = selection;
      }
    },
    // 章节点击全选
    handelSelectChapterAll(selection) {
      if (selection.length > 0) {
        this.chapters = selection;
      }
    },

    /**
     *
     * 要求用户没选择完一个曲册的章节就要点击添加 否则操作无效
     * 1 保存当前选中的章节id  在添加到当前曲册中   添加到要保存的id中都会用到
     *
     * */

    // 编辑删除课程--------------------------------------------
    //  选中已添加课程项时触发
    handleSelectionDel(val) {
      // 当点击删除的时候  将选中id的从要添加的id列表中去掉
      this.selectContentDel = val;
    },

    // 单项删除
    singleDel(index, row) {
      // 编辑  删除的时候调用接口
      this.submitDel([row.id]);
    },

    // 批量删除
    batchDel() {
      if (this.selectContentDel.length === 0)
        return this.$message("请选择要删除的内容");
      //编辑走接口
      let ids = [];
      this.selectContentDel.forEach(item => {
        ids.push(item.id);
      });
      this.submitDel(ids);
    },

    // 编辑提交删除
    submitDel(idList) {
      console.log("要删除的数据");
      console.log(idList);
      // 试着删一个
      let param = {
        courseIds: idList,
        id: this.organId
      };
      let res = this.$api.post("/customer/course/remove.json", param);
      res
        .then(
          success => {
            if (success.code) {
              this.$message({
                message: "删除成功!",
                type: "success"
              });
              //  删除成功获取课程
              this.getOrganCourses();
            } else {
              this.$message.error("删除失败！");
            }
          },
          error => {
            this.$message.error(error.msg);
          }
        )
        .catch(err => {
          this.$message.error("删除异常！");
        });
    },

    //  编辑添加课程----------------------------------------------------------
    //获取机构可分配资源
    getCourseList() {
      let param = {
        keywords: "", // 关键字 关键字，如机构名，省份，城市、地址等
        pageNum: 1, // 页数
        pageSize: 10 // 每页大小
      };

      // 判断查询条件决定获取什么数据
      if (this.search) {
        param.keywords = this.search;
      }
      let res = this.$api.get("/content/list.json", param); // 返回的是一个promise
      res
        .then(
          res => {
            // 成功才会有数据
            this.courseDataList = res.data.list;
          },
          err => {
            this.$message.error(err.msg);
          }
        )
        .catch(err => {
          console.log(err);
          this.$message.error("数据请求异常！");
        });
    },

    // 解析类目
    resolveData(str, flag) {
      let strList = str.split(",");
      if (flag === 0) {
        return strList[0] ? strList[0] : "";
      } else if (flag === 1) {
        return strList ? strList[1] : "";
      } else {
        return strList[2] ? strList[2] : "";
      }
    },

    //添加选项变动时触发
    handleSelectionAdd(val) {
      this.confirmAdd = val;
    },

    // 单项添加
    singleAdd(index, row) {
      console.log(row.id);
      // this.$message("课程已添加，请点击下一步预览");
      this.editAdd([row.id]);
    },

    // 批量添加
    batchAdd() {
      if (this.confirmAdd.length === 0)
        return this.$message("请选择要添加的内容");
      let ids = [];
      this.confirmAdd.forEach(item => {
        ids.push(item.id);
      });
      // console.log("批量添加");
      // this.$message("课程已添加，请点击下一步预览");
      console.log(ids);
      this.editAdd(ids);
    },

    // 编辑添加
    editAdd(idList) {
      let param = {
        courseList: idList, // id 列表
        id: this.organId // 机构编号
      };
      console.log(param);
      let res = this.$api.post("/customer/course/add.json", param);
      res
        .then(
          success => {
            if (success.code === 200) {
              this.$message({
                message: "添加成功!",
                type: "success"
              });
              // 重新获取已添加列表
              // this.getOrganCourses();
            } else {
              this.$message.error("添加失败！");
            }
          },
          error => {
            this.$message.error(error.msg);
          }
        )
        .catch(err => {
          console.log(err);
          this.$message.error("添加异常！");
        });
    },

    //  编辑获取机构详情
    getOrganDetail() {
      let param = {
        id: this.organId
      };
      this.$api
        .get("/customer/details.json", param)
        .then(
          success => {
            // 成功才会有数据
            this.infoFormData = success.data;
            this.$set(this.infoFormData, "code", success.data.id);
            // this.infoFormData.code = "0000";
            console.log("基本信息详情=================");
            console.log(this.infoFormData);
          },
          err => {
            this.$message.error("数据请求失败！");
          }
        )
        .catch(err => {
          console.log(err);
          this.$message.error("机构详情异常！");
        });
    },

    //协会课程搜索
    searchData() {
      this.getCourseList();
    },

    //  基本信息修改保存
    saveInfo() {
      console.log("保存的基本信息");
      console.log(this.infoFormData);
      // 基本信息非空校验
      if (this.tools.objectNotNullCheck(this.infoFormData)) {
        return this.$message.error("基本信息不能为空，请检查！");
      }

      if (!this.tools.isIntAndEg(this.infoFormData.code)) {
        return this.$message.error("机构代码只能由英文和数字组成！");
      }

      if (!this.editFlag) {
        // 密码校验   编辑不做此校验
        if (this.tools.passwordCheck(this.infoFormData.password)) {
          return this.$message.error(
            "密码长度6-16位，由字母、数字、符号,至少2项组合而成。"
          );
        }
      }
      //   学生人数 手机号整数校验
      if (this.tools.isInteger(this.infoFormData.mobile)) {
        return this.$message.error("手机号必须为整数！");
      }
      if (this.tools.isInteger(this.infoFormData.userQuota)) {
        return this.$message.error("学生人数必须为整数！");
      }
      // 时间校验  有效期大于起效期
      if (!(this.infoFormData.expireDate > this.infoFormData.validDate)) {
        return this.$message.error("开始日期必须大于结束日期！");
      }
      let res = this.$api.put("/customer/modify.json", this.infoFormData);
      res
        .then(
          success => {
            if (success.code === 200) {
              this.$message({
                message: "修改成功!",
                type: "success"
              });
              //  重新获取数据
              this.getOrganDetail();
            }
          },
          err => {
            this.$message.error(err.msg);
          }
        )
        .catch(err => {
          console.log(err);
          this.$message({
            message: "修改异常!",
            type: "warning"
          });
        });
    },

    // 删除预览  也要删除要提交的id
    deleteShowAndSubmitIds(drumIndex, albumIndex, chapterIndex, chapterId) {
      // 删除提交的id
      // this.chaptersId.splice(this.chaptersId.indexOf(chapterId), 1);
      // 删除预览的章节
      this.previewList[drumIndex].albums[albumIndex].chapters.splice(
        chapterIndex,
        1
      );
      // 判断该曲册下的章节是否为空  空则删除该曲册
      if (
        this.previewList[drumIndex].albums[albumIndex].chapters.length === 0
      ) {
        this.previewList[drumIndex].albums.splice(albumIndex, 1);
      }
      // 判断该章节下的曲册是否为空  空则删除该曲册
      if (this.previewList[drumIndex].albums.length === 0) {
        this.previewList.splice(drumIndex, 1);
      }

      console.log(this.previewList[drumIndex].albums[albumIndex].chapters);
    }
  }
};
</script>

<style scoped>
.el-container {
  margin-bottom: 20px;
}

.el-form {
  /*display: inline-block;*/
  /*margin-left: 10px;*/
  min-width: 500px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 头部布局*/
.el-header {
  color: #333;
  font-size: 12px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

/* 步骤条*/
.steps {
  width: 550px;
  margin-bottom: 50px;
}

/*头部布局结束*/

/*主体布局*/
.el-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  /*width: 100%;*/
  /*margin-left: 5px;*/
  width: initial !important;
}

/*控制步骤按钮*/
.main-button {
  width: 100px;
  display: flex;
  justify-content: center;
}

.addBtn {
  margin-left: 20px;
  margin-right: 20px;
}

/*步骤控制按钮结束*/

/* 基本信息表单内容布局 */
.el-input,
.select {
  width: 300px;
}

/*课程分配表格*/
.allocate-container {
  width: 1160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /*flex-wrap: wrap;*/
}

.table-container {
  width: 600px;
  display: flex;
}

.drum-table,
.album-table,
.chapter-table {
  /*width: 180px !important;*/
  /*margin-left: 400px;*/
}

.submit {
  height: 40px;
  margin-top: 10px;
  margin-bottom: 10px;
}

/* 添加课程结束*/

/* 已添加课程*/
.organ-added {
  width: 900px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.organ-course {
  width: 728px;
  margin-bottom: 10px;
}

/*批量操作按钮*/
.moreBtn {
  width: 728px;
  margin-top: 10px;
}

/*预览内容*/
.confirmInfo {
  width: 600px;
  border: #dbdbdb 1px solid;
}

.info-class {
  width: 100%;
}

/*头部*/
.info-title {
  width: 100%;
  height: 50px;
  display: flex;
  border-bottom: #dbdbdb 1px solid;
}

.info-title > span {
  flex: 1;
  height: 50px;
  text-align: center;
  line-height: 50px;
  box-sizing: border-box;
}

/*内容*/
.info-class-item {
  width: 100%;
  display: flex;
  text-align: center;
  margin-bottom: 10px;
  margin-top: 10px;
  font-size: 14px;
}

.drum-info {
  flex: 1;
  display: inline-block;
}

.album-info {
  flex: 3;
}

.album-info-item {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
  /*border-bottom: #888 1px solid;*/
}

.album-info-left {
  flex: 1;
}

.chapter-info {
  flex: 2;
}

.chapter-info-item {
  display: flex;
  margin-bottom: 5px;
}

.chapter-info-left {
  width: 150px;
  height: 26px;
  /*line-height: 26px;*/
}

.operate {
  flex: 1;
  /*line-height: 26px;*/
}

.delete-btn {
  display: inline-block;
  width: 26px;
  height: 18px;
  border: #dbdbdb 1px solid;
  line-height: 18px;
  color: #fff;
  border-radius: 5px;
  background-color: #f78989;
  cursor: pointer;
}

/* 小删除按钮*/
.circle-btn {
  width: 22px;
  height: 22px;
  padding: 0;
}

/*预览内容布局完毕*/

/*编辑添加课程表格布局*/
/*搜索区*/
.input-with-select {
  width: 300px;
}

/*图片*/
.video-img {
  display: inline-block;
  width: 80px;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/organManage/AddOrgan.vue